module.exports = __webpack_public_path__ + "images/etiquete_eco-c7de4f39b6ee1424dcdbcef0f1d6688b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/etiquete_eco.svg
// module id = 52
// module chunks = 0 1